module.exports = __webpack_public_path__ + "static/media/product9.70ce3018.png";